import { render, staticRenderFns } from "./about01.vue?vue&type=template&id=c36bf6ce&scoped=true&"
import script from "./about01.vue?vue&type=script&lang=js&"
export * from "./about01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36bf6ce",
  null
  
)

export default component.exports